import { render, staticRenderFns } from "./BooksQRScanner.vue?vue&type=template&id=4a48e52e&scoped=true"
import script from "./BooksQRScanner.vue?vue&type=script&lang=js"
export * from "./BooksQRScanner.vue?vue&type=script&lang=js"
import style0 from "./BooksQRScanner.vue?vue&type=style&index=0&id=4a48e52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48e52e",
  null
  
)

export default component.exports